import * as mock from "../mocks/icp.mock.js";

export function listIcp() {
  return mock.listIcp();
}
